import actionTypes from './GISAMIRS01ActionType';

/**
 * 実習結果一覧
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 実習結果一覧取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const getTrainingResultsList = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_TRAINING_RESULTS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_TRAINING_RESULTS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_TRAINING_RESULTS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_TRAINING_RESULTS_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 保険申込履歴のダウンロードReducer
 * @param {*} state
 * @param {*} action
 */
export const trainingResultsDownloadFile = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TRAINING_RESULTS_DOWNLOAD_FILE_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.TRAINING_RESULTS_DOWNLOAD_FILE_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data,
                isError: false,
                err_type: action.data.err_type == null ? "200" : action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.TRAINING_RESULTS_DOWNLOAD_FILE_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.TRAINING_RESULTS_DOWNLOAD_FILE_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
